<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      width: 100%;
    "
  >
    <div style="text-align: center">
      <span
        style="white-space: pre-wrap"
        :style="{
          fontSize: `${topLabel.size || 8}px`,
          color: topLabel.color,
        }"
        >{{ topLabel.content }}</span
      >
    </div>
    <div>
      <v-img
        v-if="loaded"
        :src="imageSrc"
        width="100%"
        height="100%"
        cover
        style="margin: auto"
        :style="{
          maxWidth: `${item.itemableAttributes.maxWidth || 375}px`,
          boxShadow: `${boxShadowX}px ${boxShadowY}px ${boxShadowBlur}px ${boxShadowSpread}px`,
        }"
      />
    </div>
    <div style="text-align: center">
      <span
        style="white-space: pre-wrap"
        :style="{
          fontSize: `${bottomLabel.size || 8}px`,
          color: bottomLabel.color,
        }"
        >{{ bottomLabel.content }}</span
      >
    </div>
  </div>
</template>

<script>
import PreviewLayout from './PreviewLayout'

export default {
  name: 'BannerItemPreview',
  components: { PreviewLayout },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageSrc: function () {
      if (this.item.itemableAttributes.imageDirectUrl) {
        return this.item.itemableAttributes.imageDirectUrl
      } else if (this.item.itemableAttributes.imagableUrl) {
        return this.item.itemableAttributes.imagableUrl
      } else {
        return `http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image`
      }
    },
    topLabel () {
      return this.item.itemableAttributes.topLabel || {}
    },
    bottomLabel () {
      return this.item.itemableAttributes.bottomLabel || {}
    },
    boxShadowX () {
      return this.item.itemableAttributes.boxShadow
        ? this.item.itemableAttributes.boxShadow.x
        : null
    },
    boxShadowY () {
      return this.item.itemableAttributes.boxShadow
        ? this.item.itemableAttributes.boxShadow.y
        : null
    },
    boxShadowBlur () {
      return this.item.itemableAttributes.boxShadow
        ? this.item.itemableAttributes.boxShadow.blur
        : null
    },
    boxShadowSpread () {
      return this.item.itemableAttributes.boxShadow
        ? this.item.itemableAttributes.boxShadow.spread
        : null
    }
  },
  data () {
    return {
      loaded: true
    }
  },
  watch: {
    'item.itemableAttributes': function (newValue, oldValue) {
      if (
        newValue.imageDirectUrl === oldValue.imageDirectUrl &&
        newValue.imagableUrl === oldValue.imagableUrl
      ) {
        return
      }
      this.reloadImage()
    }
  },
  methods: {
    reloadImage () {
      this.loaded = false
      setTimeout(() => {
        this.loaded = true
      })
    }
  }
}
</script>
